import React, {Component, ReactNode} from 'react';
import Icon from '../../icons/Icon';
import LanguageUtil from '../../util/LanguageUtil';

class CustomSidebarLayout extends Component<Props> {
  private divRef: HTMLDivElement | null = null;

  public render() {
    const {title, content, icon, visible, onHide, position = 'right', fullViewport = false} = this.props;
    const positionClass: string = position == 'right' ? 'right-0' : 'left-0';
    const placementClass: string = fullViewport ? `fixed h-screen ${positionClass} top-0 z-[50]` : `h-full absolute ${positionClass} z-[50] top-0`;
    const visibilityClass: string = visible ? `lg:w-[500px] w-full opacity-100 ${fullViewport ? '' : 'z-1'}` : 'w-0 opacity-0 z-0';

    return (
      <div
        ref={(r) => (this.divRef = r)}
        className={`${placementClass} bg-[#D9D9D94D]/30 rounded-t-lg flex items-center default-shadow ease-in-out duration-700 transition-all justify-end ${visibilityClass}`}
      >
        <div className={'flex flex-col w-[500px] h-full bg-white gap-y-1 overflow-y-auto rounded-t-lg border '}>
          <div className={'flex justify-between px-3 items-center w-full sticky top-0 border-b min-h-[51px] h-[51px] bg-[#F7F8FA]'}>
            <div className={'flex w-full gap-x-1 h-full items-center'}>
              <div className={''}>
                <Icon icon={icon} size={16} className={'text-primary'}/>
              </div>
              <div className={'text-center text-sm font-bold text-primary'}> {title}</div>
            </div>
            <div className={'flex items-center'} onClick={onHide}>
              <Icon
                icon={'multiplier'}
                size={24}
                className={'text-primary hover:bg-primary rounded hover:cursor-pointer hover:text-white'}
                onClick={() => onHide}
              />
            </div>
          </div>
          <div className={'flex w-full h-full overflow-scroll px-5 py-5'}>
            {content ? content : <div>{LanguageUtil.get({id: 'messages.warning.noContent', defaultMessage: 'There is no content'})}</div>}
          </div>
        </div>
      </div>
    );
  }

  public componentDidMount() {
    document.addEventListener('click', this.handleClickOutside);
  }

  public componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  private handleClickOutside = (event: any) => {
    const {closable} = this.props;
    if (!closable) return;
    if (this.divRef == undefined) return;
    if (this.divRef && !this.divRef.contains(event.target)) {
    }
  };
}

interface Props {
  icon: string;
  title?: string;
  content?: ReactNode;
  visible?: boolean;
  onHide: () => void;
  closable: boolean;
  position?: 'right' | 'left';
  fullViewport?: boolean;
}

export default CustomSidebarLayout;
